/* EmojiPickerCategoryHeading.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./EmojiPickerCategoryHeading.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { N900 } from '@atlaskit/theme/colors';
import { FormattedMessage } from 'react-intl-next';
import { isMessagesKey } from '../../util/type-helpers';
import { messages } from '../i18n';
var emojiCategoryTitle = null;

/**
 * Test id for wrapper Emoji Picker List div
 */
export var RENDER_EMOJI_PICKER_CATEGORY_HEADING_TESTID = 'render-emoji-picker-categorty-heading';
var EmojiPickerCategoryHeading = function EmojiPickerCategoryHeading(_ref) {
  var id = _ref.id,
    title = _ref.title,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    "data-category-id": id
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: className,
    "data-testid": RENDER_EMOJI_PICKER_CATEGORY_HEADING_TESTID,
    role: "rowheader"
  }, /*#__PURE__*/React.createElement("div", {
    className: ax(["_11c82smr _vchhusvi _syazovqm _ca0q12x7 _n3td12x7 _19bvu2gc _u5f3u2gc _1p1d1qyh _299mangw"]),
    style: {
      "--_5xk3r4": ix("var(--ds-text, ".concat(N900, ")"))
    }
  }, isMessagesKey(title) ? /*#__PURE__*/React.createElement(FormattedMessage, messages[title]) : title));
};
export default EmojiPickerCategoryHeading;